// Define the ENUMERATIVE constants 
export enum SearchModality {
  SEARCH_BY_ACCESSION_NUMBER = "SEARCH_BY_ACCESSION_NUMBER",
  SEARCH_BY_SPECIES_GENE_SEQUENCE = "SEARCH_BY_SPECIES_GENE_SEQUENCE"
}

export type NamedSearchModality = {
  name : string,
  modality : SearchModality
}


export enum Species {
  HUMAN = "HUMAN", // Human
  MOUSE = "MOUSE", // House Mouse
  RAT = "RAT", // Norway Rat
  MM = "MM", // Rhesus Monkey
  MF = "MF" // Crab-eating Macaque
}

export type NamedSpecies = {
  name : string,
  species : Species
}

export type SearchCriteria = {
  modality : SearchModality,
  species : Species,
  gene : string,
  accessionNumber : string,
  sequence : string,
}